<template>
  <div>
    <div
      style="
        border-bottom: 1px solid rgba(155, 155, 155, 0.25);
        margin-bottom: 20px;
      "
    >
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="申请企业" style="margin-right: 30px">
          <el-input v-model="formInline.name" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="申请时间">
          <el-date-picker
            :editable="false"
            :clearable="false"
            v-model="formInline.date_range"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="onSubmit"
            class="bg5584FF formBotton"
            >查询</el-button
          >
          <el-button type="info" @click="reset" class="formBotton"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div style="margin-bottom: 24px">
      <el-button type="primary" @click="toPass1(selectRow, 1)" class="bg5584FF"
        >批量通过</el-button
      >
      <el-button type="primary" @click="toPass2(selectRow, 1)" class="bg5584FF"
        >批量不通过</el-button
      >
    </div>
    <!-- <el-link style="margin-bottom: 20px;" type="primary" @click="exportData">{{exportLabel}}</el-link> -->
    <el-table
      border
      :data="tableData"
      stripe
      style="width: 100%"
      :header-cell-style="{ backgroundColor: '#DCDFE6', color: '#000' }"
      v-loading="loading"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" fixed></el-table-column>
      <el-table-column
        prop="name"
        label="申请企业"
        align="center"
        show-overflow-tooltip
        fixed
      >
        <template slot-scope="scope">
          <span class="detail" @click="handleDetail1(scope.row)">{{
            scope.row.name
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="applyName"
        label="申请人"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="申请时间"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="applyPhone"
        label="联系电话"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="reason"
        label="申请原因"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="updateStatus"
        label="状态"
        align="center"
      ></el-table-column>
      <el-table-column
        label="操作"
        align="center"
        class="dialog770 titleChange"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            class="bg5584FF"
            @click="handleDetail2(scope.row)"
            >审核</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- <div class="pageBox">
      <el-pagination
        class="pagePC"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="10"
        layout="total,  prev, pager, next"
        :total="total"
      >
      </el-pagination>
      <van-pagination
        class="pagePhone"
        v-model="currentPage"
        :total-items="total"
        :items-per-page="10"
        :show-page-size="3"
        @change="changePage"
        force-ellipses
      />
    </div> -->
    <el-dialog
      append-to-body
      title="审核意见"
      :visible.sync="passDialogVisible"
      :close-on-click-modal="false"
      class="titleChange"
      :width="screenWidth < 1200 ? '94%' : '500px'"
    >
      <el-form
        :model="passForm"
        :rules="rules"
        ref="passForm"
        label-width="135px"
        class="demo-RuleForm"
        size="small"
        v-loading="passLoading"
      >
        <el-form-item label="审核意见：" prop="reason">
          <el-input v-model="passForm.reason"></el-input>
        </el-form-item>
      </el-form>
      <div class="btnBox">
        <el-button type="primary" @click="surePass()">确定</el-button>
        <el-button @click="passDialogVisible = false">取消</el-button>
      </div>
    </el-dialog>
    <!-- 查看详情 -->
    <el-dialog
      title="企业详情"
      :visible.sync="showDetailWindow"
      :width="screenWidth < 1200 ? '94%' : '60%'"
      class="titleChange bodyScroll"
      :close-on-click-modal="false"
    >
      <div class="lineTitle">
        <span>基本信息</span>
      </div>
      <el-form
        :inline="true"
        :model="editObj"
        class="demo-form-inline half"
        size="mini"
        label-width="135px"
        label-position="right"
        ref="editForm"
      >
        <el-row>
          <el-col :xs="24" :lg="12">
            <el-form-item label="企业名称" prop="name">
              <el-input v-model.trim="editObj.name" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="统一社会信用代码">
              <el-input v-model.trim="editObj.code" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="登记注册类型">
              <el-input v-model.trim="editObj.registerType" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="国民经济行业">
              <el-input v-model.trim="editObj.industryType" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="注册资金（万元）">
              <el-input
                v-model.trim="editObj.registerMoney"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="注册时间">
              <el-input v-model="editObj.registerTime" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="法定代表人">
              <el-input
                v-model.trim="editObj.representativePerson"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="邮政编码">
              <el-input v-model.trim="editObj.postCode" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="所在工业园区">
              <el-input v-model.trim="editObj.park" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="是否规上">
              <el-input v-model.trim="editObj.aboveScale" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="是否上市">
              <el-input v-model.trim="editObj.listed" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="是否军工">
              <el-input v-model.trim="editObj.military" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="企业规模">
              <el-input v-model.trim="editObj.companySize" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="企业类别">
              <el-input
                v-model.trim="editObj.companyCategory"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="企业性质">
              <el-input
                v-model.trim="editObj.companyNature"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="“565”产业">
              <el-input v-model.trim="editObj.company565" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="是否10亿元">
              <el-input v-model.trim="editObj.oneBillion" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="提质倍增">
              <el-input
                v-model.trim="editObj.multiplication"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="是否店小二服务">
              <el-input
                v-model.trim="editObj.xiaoerService"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="“三大改造”实施">
              <el-select v-model="editObj.threeChanges" multiple disabled>
                <el-option label="智能化改造" value="智能化改造"></el-option>
                <el-option label="绿色化改造" value="绿色化改造"></el-option>
                <el-option label="技术改造" value="技术改造"></el-option>
                <el-option label="未实施" value="未实施"></el-option>
                <el-option label="已实施" value="已实施"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="注册区县" class="selection_item">
              <el-input
                class="city_input_box_1"
                v-model.trim="luoyangCity"
                disabled
                :placeholder="city_name"
              ></el-input>
              <el-input
                class="city_input_box_1"
                v-model.trim="editObj.district"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="注册地址">
              <el-input
                v-model.trim="editObj.registerAddress"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="24">
            <el-form-item label="办公地址">
              <el-input
                class="address_input_box"
                v-model.trim="editObj.officeAddress"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="24">
            <el-form-item label="公司简介">
              <el-input
                class="address_input_box"
                type="textarea"
                v-model="editObj.companyProfile"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <hr style="width: 100%; margin: 30px 0" />
        <div class="lineTitle" style="width: 100%">联系信息</div>
        <el-row>
          <el-col :xs="24" :lg="12">
            <el-form-item label="联系邮箱">
              <el-input v-model.trim="editObj.companyEmail" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="法定代表人电话">
              <el-input
                v-model.trim="editObj.representativePhone"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="联系人姓名">
              <el-input v-model.trim="editObj.contactName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="联系人职务">
              <el-input
                v-model.trim="editObj.contactPosition"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="联系手机" prop="contactPhone">
              <el-input v-model.trim="editObj.contactPhone" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="联系座机">
              <el-input
                v-model.trim="editObj.contactLandlinePhone"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <!-- 审核信息 -->
    <el-dialog
      title="企业详情"
      :visible.sync="showDetailWindow1"
      :width="screenWidth < 1200 ? '94%' : '60%'"
      class="titleChange bodyScroll"
      :close-on-click-modal="false"
    >
      <div class="lineTitle">
        <span>基本信息</span>
      </div>
      <el-form
        :inline="true"
        :model="editObj"
        class="demo-form-inline half"
        size="mini"
        label-width="135px"
        label-position="right"
        ref="editForm"
      >
        <el-row>
          <el-col :xs="24" :lg="12">
            <el-form-item label="企业名称" prop="name">
              <el-tooltip
                class="item"
                effect="dark"
                :content="editObj.nameOld"
                placement="top-start"
              >
                <el-input
                  class="information-box-color"
                  v-model.trim="editObj.name"
                  disabled
                  v-show="!editObj.nameShow"
                >
                </el-input>
              </el-tooltip>
              <el-input
                v-model.trim="editObj.name"
                disabled
                v-show="editObj.nameShow"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="统一社会信用代码">
              <el-input v-model.trim="editObj.code" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="登记注册类型">
              <el-tooltip
                class="item"
                effect="dark"
                :content="editObj.registerTypeOld"
                placement="top-start"
              >
                <el-input
                  class="information-box-color"
                  v-model.trim="editObj.registerType"
                  disabled
                  v-show="!editObj.registerTypeShow"
                ></el-input>
              </el-tooltip>
              <el-input
                v-model.trim="editObj.registerType"
                disabled
                v-show="editObj.registerTypeShow"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="国民经济行业">
              <el-tooltip
                class="item"
                effect="dark"
                :content="editObj.industryTypeOld"
                placement="top-start"
              >
                <el-input
                  class="information-box-color"
                  v-model.trim="editObj.industryType"
                  disabled
                  v-show="!editObj.industryTypeShow"
                ></el-input>
              </el-tooltip>
              <el-input
                v-model.trim="editObj.industryType"
                disabled
                v-show="editObj.industryTypeShow"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="注册资金（万元）">
              <el-tooltip
                class="item"
                effect="dark"
                :content="editObj.registerMoneyOld"
                placement="top-start"
              >
                <el-input
                  class="information-box-color"
                  v-model.trim="editObj.registerMoney"
                  disabled
                  v-show="!editObj.registerMoneyShow"
                ></el-input>
              </el-tooltip>
              <el-input
                v-model.trim="editObj.registerMoney"
                disabled
                v-show="editObj.registerMoneyShow"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="注册时间">
              <el-tooltip
                class="item"
                effect="dark"
                :content="editObj.registerTimeOld"
                placement="top-start"
              >
                <el-input
                  class="information-box-color"
                  v-model.trim="editObj.registerTime"
                  disabled
                  v-show="!editObj.registerTimeShow"
                ></el-input>
              </el-tooltip>
              <el-input
                v-model.trim="editObj.registerTime"
                disabled
                v-show="editObj.registerTimeShow"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="法定代表人">
              <el-tooltip
                class="item"
                effect="dark"
                :content="editObj.representativePersonOld"
                placement="top-start"
              >
                <el-input
                  class="information-box-color"
                  v-model.trim="editObj.representativePerson"
                  disabled
                  v-show="!editObj.representativePersonShow"
                ></el-input>
              </el-tooltip>
              <el-input
                v-model.trim="editObj.representativePerson"
                disabled
                v-show="editObj.representativePersonShow"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="邮政编码">
              <el-tooltip
                class="item"
                effect="dark"
                :content="editObj.postCodeOld"
                placement="top-start"
              >
                <el-input
                  class="information-box-color"
                  v-model.trim="editObj.postCode"
                  disabled
                  v-show="!editObj.postCodeShow"
                ></el-input>
              </el-tooltip>
              <el-input
                v-model.trim="editObj.postCode"
                disabled
                v-show="editObj.postCodeShow"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="所在工业园区">
              <el-tooltip
                class="item"
                effect="dark"
                :content="editObj.parkOld"
                placement="top-start"
              >
                <el-input
                  class="information-box-color"
                  v-model.trim="editObj.park"
                  disabled
                  v-show="!editObj.parkShow"
                >
                </el-input>
              </el-tooltip>
              <el-input
                v-model.trim="editObj.park"
                disabled
                v-show="editObj.parkShow"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="是否规上">
              <el-tooltip
                class="item"
                effect="dark"
                :content="editObj.aboveScaleOld"
                placement="top-start"
              >
                <el-input
                  class="information-box-color"
                  v-model.trim="editObj.aboveScale"
                  disabled
                  v-show="!editObj.aboveScaleShow"
                ></el-input>
              </el-tooltip>
              <el-input
                v-model.trim="editObj.aboveScale"
                disabled
                v-show="editObj.aboveScaleShow"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="是否上市">
              <el-tooltip
                class="item"
                effect="dark"
                :content="editObj.listedOld"
                placement="top-start"
              >
                <el-input
                  class="information-box-color"
                  v-model.trim="editObj.listed"
                  disabled
                  v-show="!editObj.listedShow"
                >
                </el-input>
              </el-tooltip>
              <el-input
                v-model.trim="editObj.listed"
                disabled
                v-show="editObj.listedShow"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="是否军工">
              <el-tooltip
                class="item"
                effect="dark"
                :content="editObj.militaryOld"
                placement="top-start"
              >
                <el-input
                  class="information-box-color"
                  v-model.trim="editObj.military"
                  disabled
                  v-show="!editObj.militaryShow"
                ></el-input>
              </el-tooltip>
              <el-input
                v-model.trim="editObj.military"
                disabled
                v-show="editObj.militaryShow"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="企业规模">
              <el-tooltip
                class="item"
                effect="dark"
                :content="editObj.companySizeOld"
                placement="top-start"
              >
                <el-input
                  class="information-box-color"
                  v-model.trim="editObj.companySize"
                  disabled
                  v-show="!editObj.companySizeShow"
                ></el-input>
              </el-tooltip>
              <el-input
                v-model.trim="editObj.companySize"
                disabled
                v-show="editObj.companySizeShow"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="企业类别">
              <el-tooltip
                class="item"
                effect="dark"
                :content="editObj.companyCategoryOld"
                placement="top-start"
              >
                <el-input
                  class="information-box-color"
                  v-model.trim="editObj.companyCategory"
                  disabled
                  v-show="!editObj.companyCategoryShow"
                ></el-input>
              </el-tooltip>
              <el-input
                v-model.trim="editObj.companyCategory"
                disabled
                v-show="editObj.companyCategoryShow"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="企业性质">
              <el-tooltip
                class="item"
                effect="dark"
                :content="editObj.companyNatureOld"
                placement="top-start"
              >
                <el-input
                  class="information-box-color"
                  v-model.trim="editObj.companyNature"
                  disabled
                  v-show="!editObj.companyNatureShow"
                ></el-input>
              </el-tooltip>
              <el-input
                v-model.trim="editObj.companyNature"
                disabled
                v-show="editObj.companyNatureShow"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="“565”产业">
              <el-tooltip
                class="item"
                effect="dark"
                :content="editObj.company565Old"
                placement="top-start"
              >
                <el-input
                  class="information-box-color"
                  v-model.trim="editObj.company565"
                  disabled
                  v-show="!editObj.company565Show"
                ></el-input>
              </el-tooltip>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="是否10亿元">
              <el-tooltip
                class="item"
                effect="dark"
                :content="editObj.oneBillionOld"
                placement="top-start"
              >
                <el-input
                  class="information-box-color"
                  v-model.trim="editObj.oneBillion"
                  disabled
                  v-show="!editObj.oneBillionShow"
                ></el-input>
              </el-tooltip>
              <el-input
                v-model.trim="editObj.oneBillion"
                disabled
                v-show="editObj.oneBillionShow"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="提质倍增">
              <el-tooltip
                class="item"
                effect="dark"
                :content="editObj.multiplicationOld"
                placement="top-start"
              >
                <el-input
                  class="information-box-color"
                  v-model.trim="editObj.multiplication"
                  disabled
                  v-show="!editObj.multiplicationShow"
                ></el-input>
              </el-tooltip>
              <el-input
                v-model.trim="editObj.multiplication"
                disabled
                v-show="editObj.multiplicationShow"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="是否店小二服务">
              <el-tooltip
                class="item"
                effect="dark"
                :content="editObj.xiaoerServiceOld"
                placement="top-start"
              >
                <el-input
                  class="information-box-color"
                  v-model.trim="editObj.xiaoerService"
                  disabled
                  v-show="!editObj.xiaoerServiceShow"
                ></el-input>
              </el-tooltip>
              <el-input
                v-model.trim="editObj.xiaoerService"
                disabled
                v-show="editObj.xiaoerServiceShow"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="“三大改造”实施">
              <el-tooltip
                class="item"
                effect="dark"
                :content="editObj.threeChangesOld"
                placement="top-start"
              >
                <el-input
                  class="information-box-color"
                  v-model.trim="editObj.threeChanges"
                  disabled
                  v-show="!editObj.threeChangesShow"
                ></el-input>
              </el-tooltip>
              <el-select
                v-model="editObj.threeChanges"
                multiple
                disabled
                v-show="editObj.threeChangesShow"
              >
                <el-option label="智能化改造" value="智能化改造"></el-option>
                <el-option label="绿色化改造" value="绿色化改造"></el-option>
                <el-option label="技术改造" value="技术改造"></el-option>
                <el-option label="未实施" value="未实施"></el-option>
                <el-option label="已实施" value="已实施"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="注册区县" class="selection_item">
              <el-input
                class="city_input_box_1"
                v-model.trim="luoyangCity"
                disabled
                :placeholder="city_name"
              ></el-input>
              <el-tooltip
                class="item"
                effect="dark"
                :content="editObj.districtOld"
                placement="top-start"
              >
                <el-input
                  class="information-box-color"
                  v-model.trim="editObj.district"
                  disabled
                  v-show="!editObj.districtShow"
                ></el-input>
              </el-tooltip>
              <el-input
                class="city_input_box_1"
                v-model.trim="editObj.district"
                disabled
                v-show="editObj.districtShow"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="注册地址">
              <el-tooltip
                class="item"
                effect="dark"
                :content="editObj.registerAddressOld"
                placement="top-start"
              >
                <el-input
                  class="information-box-color"
                  v-model.trim="editObj.registerAddress"
                  disabled
                  v-show="!editObj.registerAddressShow"
                ></el-input>
              </el-tooltip>
              <el-input
                v-model.trim="editObj.registerAddress"
                disabled
                v-show="editObj.registerAddressShow"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="24">
            <el-form-item label="办公地址">
              <el-tooltip
                class="item"
                effect="dark"
                :content="editObj.officeAddressOld"
                placement="top-start"
              >
                <el-input
                  class="information-box-color"
                  v-model.trim="editObj.officeAddress"
                  disabled
                  v-show="!editObj.officeAddressShow"
                ></el-input>
              </el-tooltip>
              <el-input
                class="address_input_box"
                v-model.trim="editObj.officeAddress"
                disabled
                v-show="editObj.officeAddressShow"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="24">
            <el-form-item label="公司简介">
              <el-tooltip
                class="item"
                effect="dark"
                :content="editObj.companyProfileOld"
                placement="top-start"
              >
                <el-input
                  class="information-box-color"
                  v-model.trim="editObj.companyProfile"
                  disabled
                  v-show="!editObj.companyProfileShow"
                ></el-input>
              </el-tooltip>
              <el-input
                class="address_input_box"
                v-model.trim="editObj.companyProfile"
                disabled
                v-show="editObj.companyProfileShow"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <hr style="width: 100%; margin: 30px 0" />
        <div class="lineTitle" style="width: 100%">联系信息</div>
        <el-row>
          <el-col :xs="24" :lg="12">
            <el-form-item label="联系邮箱">
              <el-tooltip
                class="item"
                effect="dark"
                :content="editObj.companyEmailOld"
                placement="top-start"
              >
                <el-input
                  class="information-box-color"
                  v-model.trim="editObj.companyEmail"
                  disabled
                  v-show="!editObj.companyEmailShow"
                ></el-input>
              </el-tooltip>
              <el-input
                v-model.trim="editObj.companyEmail"
                disabled
                v-show="editObj.companyEmailShow"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="法定代表人电话">
              <el-tooltip
                class="item"
                effect="dark"
                :content="editObj.representativePhoneOld"
                placement="top-start"
              >
                <el-input
                  class="information-box-color"
                  v-model.trim="editObj.representativePhone"
                  disabled
                  v-show="!editObj.representativePhoneShow"
                ></el-input>
              </el-tooltip>
              <el-input
                v-model.trim="editObj.representativePhone"
                disabled
                v-show="editObj.representativePhoneShow"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="联系人姓名">
              <el-tooltip
                class="item"
                effect="dark"
                :content="editObj.contactNameOld"
                placement="top-start"
              >
                <el-input
                  class="information-box-color"
                  v-model.trim="editObj.contactName"
                  disabled
                  v-show="!editObj.contactNameShow"
                ></el-input>
              </el-tooltip>
              <el-input
                v-model.trim="editObj.contactName"
                disabled
                v-show="editObj.contactNameShow"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="联系人职务">
              <el-tooltip
                class="item"
                effect="dark"
                :content="editObj.contactPositionOld"
                placement="top-start"
              >
                <el-input
                  class="information-box-color"
                  v-model.trim="editObj.contactPosition"
                  disabled
                  v-show="!editObj.contactPositionShow"
                ></el-input>
              </el-tooltip>
              <el-input
                v-model.trim="editObj.contactPosition"
                disabled
                v-show="editObj.contactPositionShow"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="联系手机" prop="contactPhone">
              <el-tooltip
                class="item"
                effect="dark"
                :content="editObj.contactPhoneOld"
                placement="top-start"
              >
                <el-input
                  class="information-box-color"
                  v-model.trim="editObj.contactPhone"
                  disabled
                  v-show="!editObj.contactPhoneShow"
                ></el-input>
              </el-tooltip>
              <el-input
                v-model.trim="editObj.contactPhone"
                disabled
                v-show="editObj.contactPhoneShow"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-form-item label="联系座机">
              <el-tooltip
                class="item"
                effect="dark"
                :content="editObj.contactLandlinePhoneOld"
                placement="top-start"
              >
                <el-input
                  class="information-box-color"
                  v-model.trim="editObj.contactLandlinePhone"
                  disabled
                  v-show="!editObj.contactLandlinePhoneShow"
                ></el-input>
              </el-tooltip>
              <el-input
                v-model.trim="editObj.contactLandlinePhone"
                disabled
                v-show="editObj.contactLandlinePhoneShow"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item style="width: 100%">
          <div class="btnBox">
            <el-button
              type="primary"
              size="mini"
              class="bg5584FF"
              @click="toPass(editObj.id)"
              >通过</el-button
            >
            <el-button type="normal" size="mini" @click="toPass(editObj.id, 0)"
              >不通过</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { export2Excel } from "@/utils/utils";
import { mapGetters } from "vuex";
export default {
  name: "index",
  props: {
    report_cycle: {
      type: String,
      default: "",
    },
    method: {
      type: String,
      default: "",
    },
    region: {
      type: String,
      default: "",
    },
    date_range: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      screenWidth: document.body.clientWidth, // 屏幕宽
      screeHeight: document.body.clientHeight, // 屏幕高
      reviseShow: false,
      showDetailWindow: false,
      showDetailWindow1: false,
      vallf: "",
      editObj: {
        code: "",
        aboveScale: "",
        aboveScaleOld: "",
        aboveScaleShow: true,
        company565: "",
        company565Old: "",
        company565Show: true,
        companyCategory: "",
        companyCategoryOld: "",
        companyCategoryShow: true,
        companyEmail: "",
        companyEmailOld: "",
        companyEmailShow: true,
        companyNature: "",
        companyNatureOld: "",
        companyNatureShow: true,
        companyProfile: "",
        companyProfileOld: "",
        companyProfileShow: true,
        companySize: "",
        companySizeOld: "",
        companySizeShow: true,
        contactLandlinePhone: "",
        contactLandlinePhoneOld: "",
        contactLandlinePhoneShow: true,
        contactName: "",
        contactNameOld: "",
        contactNameShow: true,
        contactPhone: "",
        contactPhoneOld: "",
        contactPhoneShow: true,
        contactPosition: "",
        contactPositionOld: "",
        contactPositionShow: true,
        district: "",
        districtOld: "",
        districtShow: true,
        id: "",
        industryType: "",
        industryTypeOld: "",
        industryTypeShow: true,
        listed: "",
        listedOld: "",
        listedShow: true,
        military: "",
        militaryOld: "",
        militaryShow: true,
        multiplication: "",
        multiplicationOld: "",
        multiplicationShow: true,
        name: "",
        nameOld: "",
        nameShow: true,
        officeAddress: "",
        officeAddressOld: "原值：",
        officeAddressShow: true,
        oneBillion: "",
        oneBillionOld: "",
        oneBillionShow: true,
        park: "",
        parkOld: "",
        parkShow: true,
        postCode: "",
        postCodeOld: "",
        postCodeShow: true,
        registerAddress: "",
        registerAddressOld: "",
        registerAddressShow: true,
        registerMoney: "",
        registerMoneyOld: "",
        registerMoneyShow: true,
        registerTime: "",
        registerTimeOld: "",
        registerTimeShow: true,
        registerType: "",
        registerTypeOld: "",
        registerTypeShow: true,
        representativePerson: "",
        representativePersonOld: "",
        representativePersonShow: true,
        representativePhone: "",
        representativePhoneOld: "",
        representativePhoneShow: true,
        xiaoerService: "",
        xiaoerServiceOld: "",
        xiaoerServiceShow: true,
        threeChanges: "",
        threeChangesOld: "",
        threeChangesShow: true,
      },
      tableData: [],
      currentPage: 1,
      loading: false,
      formInline: {
        //查询对象
        name: "",
        region: "",
        report_cycle: "",
        date_range: "",
        above_scale: "",
      },
      notPassForm: {
        reason: "",
      },
      regionTree: [],
      passForm: {
        reason: "",
      },
      selectRow: [],
      sureList: [],
      showObj: {},
      pageSize: 10,
      exportLabel: "<<点击此处可导出报表",
      notPassDialogVisible: false,
      passDialogVisible: false,
      notPassLoading: false,
      passLoading: false,
      total: 0, //表格总数
      rules: {
        //表单验证规则
        reason: [{ required: true, message: "请输入意见", trigger: "blur" }],
      },
      detailDialogVisible: false,
      showDialogVisible: false,
      parkList: [],
      industryList: [],
      registerList: [],
      Company565List: [],
      deftProps: {
        expandTrigger: "hover",
        label: "name",
        value: "name",
      },
      luoyangCity: "",
      city_name: "",
    };
  },
  computed: {
    ...mapGetters({
      seatList: "getAreaLists",
      seatList1: "getAreaListArr",
    }),
  },
  methods: {
    handleDetail1(row) {
      console.log(row.id);
      this.$axios
        .get(`/business/selectCompanyEditById?id=${row.id}`)
        .then((res) => {
          console.log(res.data.data);
          this.editObj = res.data.data;
          this.showDetailWindow = true;
        });
    },
    handleDetail2(row) {
      console.log(row.refId);
      var that = this;
      that.$axios
        .get(`/business/selectByCompanyId?refId=${row.refId}`)
        .then((res) => {
          console.log(res.data.data);
          var oldList = res.data.data;
          // this.editObj = res.data.data;
          // this.showDetailWindow1 = true;
          that.$axios
            .get(`/business/selectCompanyEditById?id=${row.id}`)
            .then((result) => {
              var newList = result.data.data;
              function isObjectValueEqual(a, b) {
                // return Object.values(a)
                var endList = {};
                endList.id = b.id;
                endList.code = b.code;
                if (a.name == b.name) {
                  endList.nameOld = "原值：" + a.name;
                  endList.name = b.name;
                  endList.nameShow = true;
                } else {
                  endList.nameOld = "原值：" + a.name;
                  endList.name = b.name;
                  endList.nameShow = false;
                }
                if (a.registerType == b.registerType) {
                  endList.registerTypeOld = "原值：" + a.registerType;
                  endList.registerType = b.registerType;
                  endList.registerTypeShow = true;
                } else {
                  endList.registerTypeOld = "原值：" + a.registerType;
                  endList.registerType = b.registerType;
                  endList.registerTypeShow = false;
                }
                if (a.industryType == b.industryType) {
                  endList.industryTypeOld = "原值：" + a.industryType;
                  endList.industryType = b.industryType;
                  endList.industryTypeShow = true;
                } else {
                  endList.industryTypeOld = "原值：" + a.industryType;
                  endList.industryType = b.industryType;
                  endList.industryTypeShow = false;
                }
                if (a.registerMoney == b.registerMoney) {
                  endList.registerMoneyOld = "原值：" + a.registerMoney;
                  endList.registerMoney = b.registerMoney;
                  endList.registerMoneyShow = true;
                } else {
                  if (a.registerMoney == null) {
                    endList.registerMoneyOld = "原值：" + "";
                  } else {
                    endList.registerMoneyOld = "原值：" + a.registerMoney;
                  }

                  endList.registerMoney = b.registerMoney;
                  endList.registerMoneyShow = false;
                }
                if (a.registerTime == b.registerTime) {
                  endList.registerTimeOld = "原值：" + a.registerTime;
                  endList.registerTime = b.registerTime;
                  endList.registerTimeShow = true;
                } else {
                  endList.registerTimeOld = "原值：" + a.registerTime;
                  endList.registerTime = b.registerTime;
                  endList.registerTimeShow = false;
                }
                if (a.representativePerson == b.representativePerson) {
                  endList.representativePersonOld =
                    "原值：" + a.representativePerson;
                  endList.representativePerson = b.representativePerson;
                  endList.representativePersonShow = true;
                } else {
                  endList.representativePersonOld =
                    "原值：" + a.representativePerson;
                  endList.representativePerson = b.representativePerson;
                  endList.representativePersonShow = false;
                }
                if (a.postCode == b.postCode) {
                  endList.postCodeOld = "原值：" + a.postCode;
                  endList.postCode = b.postCode;
                  endList.postCodeShow = true;
                } else {
                  endList.postCodeOld = "原值：" + a.postCode;
                  endList.postCode = b.postCode;
                  endList.postCodeShow = false;
                }
                if (a.park == b.park) {
                  endList.parkOld = "原值：" + a.park;
                  endList.park = b.park;
                  endList.parkShow = true;
                } else {
                  endList.parkOld = "原值：" + a.park;
                  endList.park = b.park;
                  endList.parkShow = false;
                }
                if (a.aboveScale == b.aboveScale) {
                  endList.aboveScaleOld = "原值：" + a.aboveScale;
                  endList.aboveScale = b.aboveScale;
                  endList.aboveScaleShow = true;
                } else {
                  endList.aboveScaleOld = "原值：" + a.aboveScale;
                  endList.aboveScale = b.aboveScale;
                  endList.aboveScaleShow = false;
                }
                if (a.listed == b.listed) {
                  endList.listedOld = "原值：" + a.listed;
                  endList.listed = b.listed;
                  endList.listedShow = true;
                } else {
                  endList.listedOld = "原值：" + a.listed;
                  endList.listed = b.listed;
                  endList.listedShow = false;
                }
                if (a.military == b.military) {
                  endList.militaryOld = "原值：" + a.military;
                  endList.military = b.military;
                  endList.militaryShow = true;
                } else {
                  endList.militaryOld = "原值：" + a.military;
                  endList.military = b.military;
                  endList.militaryShow = false;
                }
                if (a.companySize == b.companySize) {
                  endList.companySizeOld = "原值：" + a.companySize;
                  endList.companySize = b.companySize;
                  endList.companySizeShow = true;
                } else {
                  endList.companySizeOld = "原值：" + a.companySize;
                  endList.companySize = b.companySize;
                  endList.companySizeShow = false;
                }
                if (a.companyCategory == b.companyCategory) {
                  endList.companyCategoryOld = "原值：" + a.companyCategory;
                  endList.companyCategory = b.companyCategory;
                  endList.companyCategoryShow = true;
                } else {
                  endList.companyCategoryOld = "原值：" + a.companyCategory;
                  endList.companyCategory = b.companyCategory;
                  endList.companyCategoryShow = false;
                }
                if (a.companyNature == b.companyNature) {
                  endList.companyNatureOld = "原值：" + a.companyNature;
                  endList.companyNature = b.companyNature;
                  endList.companyNatureShow = true;
                } else {
                  endList.companyNatureOld = "原值：" + a.companyNature;
                  endList.companyNature = b.companyNature;
                  endList.companyNatureShow = false;
                }
                if (a.company565 == b.company565) {
                  endList.company565Old = "原值：" + a.company565;
                  endList.company565 = b.company565;
                  endList.company565Show = true;
                } else {
                  endList.company565Old = "原值：" + a.company565;
                  endList.company565 = b.company565;
                  endList.company565Show = false;
                }
                if (a.oneBillion == b.oneBillion) {
                  endList.oneBillionOld = "原值：" + a.oneBillion;
                  endList.oneBillion = b.oneBillion;
                  endList.oneBillionShow = true;
                } else {
                  endList.oneBillionOld = "原值：" + a.oneBillion;
                  endList.oneBillion = b.oneBillion;
                  endList.oneBillionShow = false;
                }
                if (a.multiplication == b.multiplication) {
                  endList.multiplicationOld = "原值：" + a.multiplication;
                  endList.multiplication = b.multiplication;
                  endList.multiplicationShow = true;
                } else {
                  endList.multiplicationOld = "原值：" + a.multiplication;
                  endList.multiplication = b.multiplication;
                  endList.multiplicationShow = false;
                }
                if (a.xiaoerService == b.xiaoerService) {
                  endList.xiaoerServiceOld = "原值：" + a.xiaoerService;
                  endList.xiaoerService = b.xiaoerService;
                  endList.xiaoerServiceShow = true;
                } else {
                  endList.xiaoerServiceOld = "原值：" + a.xiaoerService;
                  endList.xiaoerService = b.xiaoerService;
                  endList.xiaoerServiceShow = false;
                }
                if (a.district == b.district) {
                  endList.districtOld = "原值：" + a.district;
                  endList.district = b.district;
                  endList.districtShow = true;
                } else {
                  endList.districtOld = "原值：" + a.district;
                  endList.district = b.district;
                  endList.districtShow = false;
                }
                if (a.registerAddress == b.registerAddress) {
                  endList.registerAddressOld = "原值：" + a.registerAddress;
                  endList.registerAddress = b.registerAddress;
                  endList.registerAddressShow = true;
                } else {
                  endList.registerAddressOld = "原值：" + a.registerAddress;
                  endList.registerAddress = b.registerAddress;
                  endList.registerAddressShow = false;
                }
                if (a.officeAddress == b.officeAddress) {
                  endList.officeAddressOld = "原值：" + a.officeAddress;
                  endList.officeAddress = b.officeAddress;
                  endList.officeAddressShow = true;
                } else {
                  endList.officeAddressOld = "原值：" + a.officeAddress;
                  endList.officeAddress = b.officeAddress;
                  endList.officeAddressShow = false;
                }
                if (a.companyProfile == b.companyProfile) {
                  endList.companyProfileOld = "原值：" + a.companyProfile;
                  endList.companyProfile = b.companyProfile;
                  endList.companyProfileShow = true;
                } else {
                  endList.companyProfileOld = "原值：" + a.companyProfile;
                  endList.companyProfile = b.companyProfile;
                  endList.companyProfileShow = false;
                }
                if (a.companyEmail == b.companyEmail) {
                  endList.companyEmailOld = "原值：" + a.companyEmail;
                  endList.companyEmail = b.companyEmail;
                  endList.companyEmailShow = true;
                } else {
                  endList.companyEmailOld = "原值：" + a.companyEmail;
                  endList.companyEmail = b.companyEmail;
                  endList.companyEmailShow = false;
                }
                if (a.representativePhone == b.representativePhone) {
                  endList.representativePhoneOld =
                    "原值：" + a.representativePhone;
                  endList.representativePhone = b.representativePhone;
                  endList.representativePhoneShow = true;
                } else {
                  endList.representativePhoneOld =
                    "原值：" + a.representativePhone;
                  endList.representativePhone = b.representativePhone;
                  endList.representativePhoneShow = false;
                }
                if (a.contactName == b.contactName) {
                  endList.contactNameOld = "原值：" + a.contactName;
                  endList.contactName = b.contactName;
                  endList.contactNameShow = true;
                } else {
                  endList.contactNameOld = "原值：" + a.contactName;
                  endList.contactName = b.contactName;
                  endList.contactNameShow = false;
                }
                if (a.contactPosition == b.contactPosition) {
                  endList.contactPositionOld = "原值：" + a.contactPosition;
                  endList.contactPosition = b.contactPosition;
                  endList.contactPositionShow = true;
                } else {
                  endList.contactPositionOld = "原值：" + a.contactPosition;
                  endList.contactPosition = b.contactPosition;
                  endList.contactPositionShow = false;
                }
                if (a.contactPhone == b.contactPhone) {
                  endList.contactPhoneOld = "原值：" + a.contactPhone;
                  endList.contactPhone = b.contactPhone;
                  endList.contactPhoneShow = true;
                } else {
                  endList.contactPhoneOld = "原值：" + a.contactPhone;
                  endList.contactPhone = b.contactPhone;
                  endList.contactPhoneShow = false;
                }
                if (a.contactLandlinePhone == b.contactLandlinePhone) {
                  endList.contactLandlinePhoneOld =
                    "原值：" + a.contactLandlinePhone;
                  endList.contactLandlinePhone = b.contactLandlinePhone;
                  endList.contactLandlinePhoneShow = true;
                } else {
                  endList.contactLandlinePhoneOld =
                    "原值：" + a.contactLandlinePhone;
                  endList.contactLandlinePhone = b.contactLandlinePhone;
                  endList.contactLandlinePhoneShow = false;
                }
                var strThreeA = a.threeChanges.join(" ");
                var strThreeB = b.threeChanges.join(" ");

                if (strThreeA === strThreeB) {
                  endList.threeChangesOld = "原值：" + a.threeChanges;
                  endList.threeChanges = b.threeChanges;
                  endList.threeChangesShow = true;
                } else {
                  endList.threeChangesOld = "原值：" + a.threeChanges;
                  endList.threeChanges = b.threeChanges;
                  endList.threeChangesShow = false;
                }

                return endList;
              }

              console.log(isObjectValueEqual(oldList, newList));

              // that.editObj = result.data.data;
              that.editObj = isObjectValueEqual(oldList, newList);
              that.showDetailWindow1 = true;
            });
        });
    },
    getdata(page) {
      this.loading = true;
      this.tableData = [];
      const param = {
        pageNum: page || 1,
        pageSize: this.pageSize,
        status: 1,
      };
      if (this.formInline.name !== "") {
        param["companyName"] = this.formInline.name;
      }
      if (this.formInline.date_range && this.formInline.date_range !== "") {
        // param["date"] = this.$moment(this.formInline.date_range).format(
        //   "YYYY-MM"
        // );
        param["date"] = this.formInline.date_range;
      }

      let methods = "/business/selectCompanyUpdateMsg";
      // if (this.method === 'noRole') {
      //   methods = '/business/insertMonitor/showCompanyByName'
      // }
      console.log(param);
      this.$axios.get(methods, { params: param }).then((res) => {
        this.loading = false;
        console.log(res.data.data.list);
        res.data.data.list.forEach((item) => {
          item.createTime = item.createTime.slice(0, 10);
          if (item.updateStatus == 1) {
            item.updateStatus = "已提交";
          }
        });
        this.tableData = res.data.data.list;
        console.log(this.tableData);
        this.total = res.data.data.total;
      });
    },
    toDetail(row) {
      this.showDialogVisible = true;
    },
    handleDetail(row) {
      this.showObj = row;
      this.detailDialogVisible = true;
    },
    surePass() {
      this.$refs.passForm.validate((valid) => {
        console.log(valid);
        if (valid) {
          // this.passLoading = true;
          // alert(this.valf)
          const param = {
            opinion: this.passForm.reason,
            id: this.sureList,
            status: "",
          };
          if (this.valf == 0) {
            param.status = 3;
          } else {
            param.status = 2;
          }

          this.$axios
            .put(
              `/business/updateStatusMsg?id=${param.id}&opinion=${param.opinion}&status=${param.status}`
            )
            .then((res) => {
              console.log(res);
              // this.$message.success("催报成功")
              this.getdata(1);
              this.passLoading = false;
              this.passDialogVisible = false;
              this.showDetailWindow1 = false;
            });
        }
      });
    },
    surenoPass() {
      this.$refs.passForm.validate((valid) => {
        console.log(valid);
        if (valid) {
          this.passLoading = true;
          const param = {
            opinion: this.passForm.reason,
            id: this.sureList,
            status: 3,
          };
          console.log(param);
          this.$axios
            .put(
              `/business/updateStatusMsg?id=${param.id}&opinion=${param.opinion}&status=${param.status}`
            )
            .then((res) => {
              console.log(res);
              // this.$message.success("催报成功")
              this.getdata(1);
              this.passLoading = false;
              this.passDialogVisible = false;
              this.showDetailWindow1 = false;
            });
        }
      });
    },
    toPass(rowList, valf) {
      if (rowList.length) {
        this.sureList = rowList;
        this.valf = valf;
        this.passForm = {
          reason: "",
        };
        this.passDialogVisible = true;
      }
    },
    toPass1(rowList) {
      console.log(rowList);
      var newRowList = [];
      for (var i = 0; i < rowList.length; i++) {
        let obj = {
          id: rowList[i],
          opinion: "同意",
          status: 2,
        };
        newRowList.push(obj);
      }
      console.log(rowList);
      console.log(newRowList);
      this.$axios.put(`/business/updateStatusBatch`, newRowList).then((res) => {
        console.log(res);
        this.$message.success("批量审核通过成功");
        this.getdata(1);
        this.passLoading = false;
        // this.passDialogVisible = false;
        // this.showDetailWindow1 = false;
      });
    },
    toPass2(rowList) {
      console.log(rowList);
      var newRowList = [];
      for (var i = 0; i < rowList.length; i++) {
        let obj = {
          id: rowList[i],
          opinion: "不同意",
          status: 3,
        };
        newRowList.push(obj);
      }
      console.log(rowList);
      console.log(newRowList);
      this.$axios.put(`/business/updateStatusBatch`, newRowList).then((res) => {
        console.log(res);
        this.$message.success("批量审核不通过成功");
        this.getdata(1);
        this.passLoading = false;
        // this.passDialogVisible = false;
        // this.showDetailWindow1 = false;
      });
    },
    handleSelectionChange(rowTable) {
      this.selectRow = [];
      rowTable.forEach((temp) => {
        this.selectRow.push(temp.id);
      });
    },
    changePage() {
      this.pageNum = this.currentPage;
      this.getdata(this.currentPage);
    },
    handleCurrentChange(val) {
      //跳转页
      this.getdata(val);
    },
    onSubmit() {
      this.getdata(1);
    },
    reset() {
      this.formInline = {
        name: "",
        region: this.region,
        report_cycle: this.report_cycle,
        date_range: this.date_range,
        above_scale: "",
      };
      this.getdata(1);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getdata(1);
    },
    exportData() {
      let column = [
        {
          title: "填报单位",
          key: "company_name",
        },
        {
          title: "报表名",
          key: "name",
        },
        {
          title: "填报期",
          key: "date_range",
        },
        {
          title: "填报开始时间",
          key: "date_range",
        },
        {
          title: "填报结束时间",
          key: "date_range_end",
        },
        {
          title: "上报时间",
          key: "crt_time",
        },
      ];
      export2Excel(column, this.tableData, "未上报");
    },
  },
  created() {
    if (this.report_cycle) {
      this.formInline.report_cycle = this.report_cycle;
    }
    if (this.region) {
      this.formInline.region = this.region;
    }
    if (this.date_range) {
      this.formInline.date_range = this.date_range;
    }
    this.getdata();
    if (this.seatList1.length) {
      this.city_name = this.seatList1[0];
    }
  },
  mounted() {
    window.onresize = () => {
      this.screenWidth = document.body.clientWidth;
    };
  },
};
</script>

<style>
.detail {
  width: 100%;
  height: 100%;
  cursor: pointer;
  color: #5584ff;
}

.information-box {
  position: relative;
  display: block;
}

.information-box-color {
  color: #ff7300 !important;
}

.information-box-color input {
  color: #ff7300 !important;
}

.information-box:hover span.tipSpan {
  display: block;
}

span.tipSpan {
  position: absolute;
  background-color: #3595cc;
  padding: 0 8px;
  border-radius: 4px;
  top: -30px;
  left: 0;
  width: auto;
  font-size: 12px;
  color: #ffffff;
  display: none;
}

.tipSpan:after {
  position: absolute;
  content: "";
  top: 24px;
  left: 10px;
  border-top: 10px solid #3595cc;
  border-left: 10px solid transparent;
}
.pagePhone {
  display: none;
}

@media (max-width: 1200px) {
  .pagePC {
    display: none;
  }
  .pagePhone {
    display: flex;
  }
}
</style>